import React from 'react';
import { useSelector } from 'react-redux';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';

import { selectCreatedPaymentAddress, selectTagValue } from 'src/store/slice/payment/state';

import { useWidgetHelp } from 'src/hook';
import { useAppContext } from 'src/context/useAppContext';

import './qr-code-box.scss';

const QRCodeBox: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  const { currency } = useAppContext();
  const { isRequesSuccess } = useWidgetHelp();

  const createdPaymentAddress = useSelector(selectCreatedPaymentAddress);

  const { currency_id: selectedCurrencyId, network: selectedCurrencyNetwork } = currency;

  return (
    <section className={`qr-code-box ${!isRequesSuccess ? 'skeleton-loader' : ''}`}>
      <p className="qr-code-box-qr">
        <QRCode
          value={`${createdPaymentAddress}`}
          style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
          viewBox={`0 0 256 256`}
        />
      </p>

      <p className="qr-code-box-description">
        {t('DESCRIPTION_QR_CODE.SEND_CURRENCY', {
          currency: `${selectedCurrencyId} (${selectedCurrencyNetwork})`,
        })}
      </p>
    </section>
  );
};

export default QRCodeBox;
